import axios from 'axios';

const api = axios.create({
  baseURL: 'https://certificate-fastapi-tjhyfw3rsq-uc.a.run.app',
});

export default api;
